@import 'styles/mixins';
@import 'styles/variables';

.container {
  display: none;
  user-select: none;
  padding-left: 8px;
  padding-right: 4px;

  @include for-desktop-up {
    display: flex;
    justify-content: flex-end;
  }
}

.dropdownItem {
  display: flex;
}

.dropdownName {
  @include ui-sm-text;
  padding-left: 6px;
  padding-top: 4px;
}

.avatarContainer {
  margin-left: -4px;
  cursor: pointer;
  border: 2px solid white;
  border-radius: 50%;
  height: 28px;

  [data-design-system='blaze'] & {
    border: none;
  }
}
